import { fetchAllBillboards } from '@/features/billboards/api/billboardApi';
import { DEFAULT_CITY } from '@/features/landing/components/discoveryTypes';
import { queryClient } from '@/shared/lib/query/queryClient';
import { queryKeys } from '@/shared/lib/query/queryKeys';

export const SCREENS_LIST_DEFAULTS = { page: 1, limit: 15 } as const;

export function prefetchScreensList(city?: string | null) {
  const params = {
    ...SCREENS_LIST_DEFAULTS,
    city: city || DEFAULT_CITY,
  };

  return queryClient.prefetchQuery({
    queryKey: queryKeys.billboards.list(params),
    queryFn: () => fetchAllBillboards(params),
  });
}
